import React from "react";
import ReactPlayer from "react-player/vimeo";
import { VideoDiv } from "../../components/shared/Video/VideoEmbed.styles";
import { useAuthenticationHook } from "../../utils/hooks/useAuthenticationHook";
import { TrackAnalyticsEvent } from "../../services/Analytics";
import { AnalyticsEventNames } from "../../utils/analyticsEvents";

// Desktop-only sizing since we only support desktop view
const getWidth = () => "760px";
const getHeight = () => "442px";

const VideoLibraryCard: React.FC<{
  name: string;
  url: string;
  image: string;
}> = ({ name, url, image }) => {
  const { auth } = useAuthenticationHook();

  return (
    <VideoDiv>
      <ReactPlayer
        playing
        url={url}
        light={image}
        height={getHeight()}
        width={getWidth()}
        controls
        data-testid="unity-video-player"
        data-vimeo-playsinline
        data-vimeo-autoplay
        onPlay={() => {
          if (auth?.token) {
            TrackAnalyticsEvent(
              `${AnalyticsEventNames.VideoLibraryCardVideoClicked}-${name}`,
              auth.token,
              auth.username,
            );
          }
        }}
      />
    </VideoDiv>
  );
};

export default VideoLibraryCard;
